<script lang="ts" setup>
import { ElFormItem, ElAlert } from "element-plus";
import { useI18n } from "vue-i18n";
import CoreButton from "../CoreButton/CoreButton.vue";
import { computed, ref, watch } from "vue";
import { useDownloadUtils } from "@/composables/download";

export interface Props {
  modelValue?: string[];
  label: string;
  visitorName?: string;
}

const props = defineProps<Props>();

const documentList = ref<string[]>(props.modelValue ?? []);

const canDownload = computed(
  () =>
    documentList.value?.length > 0 &&
    documentList.value.every((val) => Boolean(val))
);

const { t } = useI18n();
const { downloadDocument, isDownloading } = useDownloadUtils();

const handleDownloadDocument = async () => {
  await downloadDocument(
    documentList.value[0],
    documentList.value[1],
    props.label,
    props.visitorName
  );
};

watch(
  () => props.modelValue,
  (value) => (documentList.value = value ?? [])
);
</script>

<template>
  <el-form-item :label="label">
    <CoreButton
      v-if="canDownload"
      :loading="isDownloading[label]"
      text
      type="primary"
      :icon="['fal', 'file-image']"
      @click="handleDownloadDocument"
    >
      {{ t("visitors.fields.downloadDocument") }}
    </CoreButton>
    <span
      v-else-if="visitorName"
      class="no-document"
    >
      {{ t("visitors.fields.noDocumentProvided") }}
    </span>
    <el-alert
      v-else
      type="info"
      show-icon
      :title="t('visitors.fields.documentUploadNotSupported')"
      :closable="false"
    />
  </el-form-item>
</template>

<style lang="scss" scoped>
.no-document {
  color: var(--so-color-contrast);
}
</style>
